import classNames from 'classnames'
import { Button, TextInput } from 'journey-ui'
import React, { useContext } from 'react'
import { ItemPageContext } from '../../contexts/ItemPageContext'

interface Props {
  className?: string
}

export const ItemQuantityInput: React.FC<Props> = ({ className }) => {
  const { setForm, form } = useContext(ItemPageContext)
  const setQuantity = (newQuantity) => {
    newQuantity = Math.max(1, newQuantity)

    const pricePerItem = form.price / form.quantity

    // Update addon prices.
    const newChildren = form.children.map((c) => {
      const pricePerChild = c.price / c.quantity

      return {
        ...c,
        quantity: newQuantity,
        price: pricePerChild * newQuantity,
      }
    })

    setForm((form) => ({
      ...form,
      price: pricePerItem * newQuantity,
      children: newChildren,
      quantity: newQuantity,
    }))
  }

  return (
    <div className={classNames('flex items-center space-x-2 mt-0', className)}>
      <div className="bg-white flex flex-nowrap border-2 border-dashed rounded-full border-gray items-center flex-shrink-0 p-1 space-x-2">
        <Button className="h-8 px-5 min-h-0 text-xl" onClick={() => setQuantity(form.quantity + 1)}>+</Button>
        <TextInput
          className="w-14 h-8 rounded-full min-h-0 no-arrows quantity-input"
          type="number"
          value={form.quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
        />
        <Button className="h-8 px-5 min-h-0 text-xl" onClick={() => setQuantity(form.quantity - 1)}>-</Button>
      </div>
    </div>
  )
}
